<template>
  <div class="report-filter" :key="updateKey">
    <!-- Toggler -->
    <div class="toggler">
      <div class="left">
        <input :checked="isFilterEnabled"
               @change="toggleFilter(filterKey)"
            type="checkbox">
      </div>
      <div class="right">
        <a href="#" @click.prevent="toggleFilter(filterKey)"><b>Difficulty</b></a>
      </div>
    </div>
    <!-- / Toggler -->

    <!-- Options -->
    <div class="options" v-if="isFilterEnabled">
<!--      {{ filtersEnabled }}-->
      <v-select :options="ticketDifficultyDropdownOptions" label="label" multiple
                :reduce="status => status.value"
                @option:selected="incrementUpdateKey"
                @option:deselected="incrementUpdateKey"
      :value="params['difficulty']" @input="setDifficultyFilter"></v-select>
    </div>
    <!-- / Options -->
  </div>
</template>

<script>
import {mapActions, mapGetters} from "vuex";
import Tickets from "../../../../../mixins/Tickets";

export default {
  name: "DifficultyFilter",
  mixins: [Tickets],
  data() {
    return {
      filterKey: 'difficulty',
      updateKey: 1
    }
  },
  methods: {
    ...mapActions('reportEditor', {
      toggleFilter: 'toggleFilter',
      setDifficultyFilter: 'setDifficultyFilter'
    }),

    incrementUpdateKey() {
      this.updateKey += 1;
    }
  },
  computed: {
    ...mapGetters('reportEditor', {
      filtersEnabled: 'filtersEnabled',
      params: 'params'
    }),

    isFilterEnabled() {
      return this.filtersEnabled.includes(this.filterKey);
    }
  }
}
</script>

<style lang="scss" scoped>
.report-filter {
  background: #fff;
  border-radius: 5px;
  padding: 13px 15px;
  margin-bottom: 15px;

  .toggler {
    display: flex;
    flex-direction: row;
    align-items: center;

    .left {
      flex-shrink: 1;
      padding-top: 4px;
      padding-right: 15px;
    }

    .right {
      flex: 1;
      font-weight: 600;
      color: #2c5cc5;
    }
  }

  .options {
    margin-top: 10px;
  }
}
</style>